import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import classes from "./Header.module.css";
import NavLinks from "./NavLinks";
import SideDrawer from "./SideDrawer";
import Search from "./Search";
import useWindowDimensions from "../../hooks/screen-width";
import Modal from "../../components/Modal/Modal";

const Header = props => {
  const [isMoving, setIsMoving] = useState(false);

  const handleScroll = () => {
    const scroll = window.scrollY > 70;
    if (scroll) {
      setIsMoving(true);
    } else {
      setIsMoving(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [drawerIsOpen, setDrawerIsOpen] = useState(false);

  const openDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  const { width } = useWindowDimensions();
  let logo = 'HD Film Plus';
  let search = <Search search={props.onSearching} />;
  let menuButton = <i onClick={openDrawerHandler} className="fas fa-bars"></i>;
  if (width < 768) {
    //search = null;
    logo = 'HD Film';
  } else {
    menuButton = null;
  }

  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <React.Fragment>
      <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
        <nav className={classes.MainNav}>
          <NavLinks />
        </nav>
      </SideDrawer>

      <Modal
        show={showModal}
        onCancel={closeModal}
        header={"Hesap"}
        footer={"Butonlar Buraya Gelecek"}
      >
        Giriş Form Elemanları Buraya Gelecek
      </Modal>

      <div
        className={`${classes.Header} ${isMoving ? classes.Moving : undefined}`}
      >
        <div className={classes.Left}>
          <Link to="/" className={classes.Logo}>
            {logo}
            <span>+</span>
            <div className={classes.Version}>alpha build</div>
          </Link>
          <nav className={classes.MainNav}>
            <NavLinks />
          </nav>
        </div>
        <nav className={classes.Right}>
          {search}
          <i onClick={openModal} className="fas fa-user"></i>
          {menuButton}
        </nav>
      </div>
    </React.Fragment>
  );
};

export default Header;
